import type { Directive } from 'vue'
import autoAnimate, { AutoAnimateOptions } from '@formkit/auto-animate'

export function useAutoAnimateConfig(
    duration: number
): Partial<AutoAnimateOptions>
export function useAutoAnimateConfig(
    config: Partial<AutoAnimateOptions>
): Partial<AutoAnimateOptions>
export function useAutoAnimateConfig(
    configOrDuration: number | Partial<AutoAnimateOptions>
): Partial<AutoAnimateOptions> {
    const isDuration = typeof configOrDuration === 'number'

    if (isDuration) {
        return {
            duration: configOrDuration,
        }
    }
    return configOrDuration
}

export const autoAnimateDirective = <
    Directive<HTMLElement, Partial<AutoAnimateOptions>>
>{
    inserted(el, binding) {
        autoAnimate(el, binding.value)
    },
}
